import LogoTheTreep from "@/assets/logo_thetreep.svg";
import FlagFr from "@/assets/flag_fr.svg";
import FlagEn from "@/assets/flag_en.svg";
import { useTranslation } from "react-i18next";
import { Icon, Svg } from "@thetreep/ui";
import { routes } from "@routes";
import { useNavigationGuard } from "@hooks/useNavigationGuard";
import { useState } from "react";
import { WarningModal } from "@pages/booking/exchange/WarningModal";
import { useSearchParams } from "react-router";
import { useMatch } from "react-router";
export function TopBar() {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  const isExchange = useMatch(routes.EXCHANGE);
  const isExchangeSearch = useMatch(routes.EXCHANGE_SEARCH);
  const isExchangeResult = useMatch(routes.EXCHANGE_RESULTS);
  const isExchangeRecap = useMatch(routes.EXCHANGE_RECAP);

  // ou autre logique pour savoir si on doit bloquer
  const shouldBlock = Boolean(
    isExchange || isExchangeSearch || isExchangeResult || isExchangeRecap,
  );
  const [blockNavigation, setBlockNavigation] = useState(shouldBlock);
  const [prevShouldBlock, setPrevShouldBlock] = useState(shouldBlock);
  if (shouldBlock !== prevShouldBlock) {
    setPrevShouldBlock(shouldBlock);
    setBlockNavigation(shouldBlock);
  }

  const [searchParams] = useSearchParams();
  const dapValue = searchParams.get("dap");
  const dapName = searchParams.get("dap_name");
  const [dap, setDap] = useState<string | null>(dapValue);
  const [name, setName] = useState<string | null>(dapName);
  const [prevSearchParams, setPrevSearchParams] = useState(searchParams);
  if (searchParams !== prevSearchParams) {
    setPrevSearchParams(searchParams);
    setDap(dapValue);
    setName(dapName);
  }

  const { handleNavigate, showPrompt, confirmNavigation, cancelNavigation } =
    useNavigationGuard(blockNavigation);

  return (
    <div className="w-full h-12 px-5 md:px-8 lg:px-24 xl:px-48  bg-[#07275c] justify-between items-center inline-flex">
      <div className="h-4 justify-start items-center gap-[5px] flex">
        <div className="text-white text-sm leading-none">
          {t("header.poweredBy")}
        </div>
        <Svg src={LogoTheTreep} color="white" width="85px" />
      </div>
      <div className="h-8 justify-end items-center gap-4 md:gap-10 flex">
        <div
          className="justify-start items-center gap-2 flex cursor-pointer"
          onClick={() => handleNavigate(routes.HELP)}
        >
          <Icon src="information_line" color="white" size={24} />
          <div className="hidden md:block text-white text-base">
            {t("header.help")}
          </div>
        </div>
        <div
          className="justify-start items-center gap-2 flex cursor-pointer"
          onClick={() =>
            handleNavigate(routes.CONTACT, dap ? dap : null, name ? name : "")
          }
        >
          <Icon src="phone_line" color="white" size={24} />
          <div className="hidden md:block text-white text-base ">
            {t("header.contact")}
          </div>
        </div>
        <div className="h-6 md:h-8 flex cursor-pointer">
          {currentLanguage === "fr" ? (
            <div
              onClick={() => changeLanguage("en")}
              className="md:hidden  relative flex-1 p-2 bg-[#1c4094] rounded-lg border text-white border-white justify-center items-center gap-2 flex"
            >
              <Svg src={FlagFr} width="16px" />
              <div className="text-base">FR</div>
            </div>
          ) : (
            <div
              onClick={() => changeLanguage("fr")}
              className="md:hidden relative flex-1 p-2 bg-[#1c4094] rounded-lg border text-white border-white justify-center items-center gap-2 flex"
            >
              <Svg src={FlagEn} width="16px" />
              <div className="text-base">EN</div>
            </div>
          )}
          <div className="hidden md:flex">
            <div
              onClick={() => changeLanguage("fr")}
              className={`relative flex-1 p-2 bg-[#1c4094] rounded-lg border ${
                currentLanguage === "fr"
                  ? "text-white border-white z-[2]"
                  : "text-[#9ba8c8] pr-4 z-1 border-[#9ba8c8]"
              } justify-center items-center gap-2 flex relative md:left-2`}
            >
              <Svg src={FlagFr} width="16px" />
              <div className="text-base">FR</div>
            </div>
            <div
              onClick={() => changeLanguage("en")}
              className={`relative flex-1 pl-4 pr-2 bg-[#1c4094] rounded-lg border ${
                currentLanguage === "en"
                  ? "text-white border-white z-2 pl-[8px]"
                  : "text-[#9ba8c8] z-1 border-[#9ba8c8]"
              } justify-center items-center gap-2 flex`}
            >
              <Svg src={FlagEn} width="16px" />
              <div className="text-base">EN</div>
            </div>
          </div>
        </div>
      </div>
      {showPrompt && (
        <WarningModal
          onConfirm={confirmNavigation}
          onClose={cancelNavigation}
          isOpen={showPrompt}
        />
      )}
    </div>
  );
}
